import React from 'react'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { ArrowLeft2 } from 'iconsax-react'

import NewCount from '../BaseConversation/NewCount'

import { ANIMATION_DURATION } from '../BaseConversation/NewCount/styles'
import { selectNotification } from '@SonarCX/slices/notification'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import { useQueueState } from '@SonarCX/providers/QueueStateProvider'
import useStyles from './styles'

const NotificationBackButton = ({ show, onClick, hideCount }) => {
  const { unread } = useAppSelector(selectNotification)
  const { user } = useEnvironment()
  const { id: current, conversations } = useQueueState()

  const [blink, setBlink] = React.useState(false)
  const notifications = React.useMemo(() => Object.values(unread), [unread])

  // Decides if any blinking should occur
  React.useEffect(() => {
    const id = user?.id
    if (!id) {
      return
    }

    const convos = Object.values(conversations)

    // Check for new messages
    const anyAreUpdated = convos.some(convo => convo.isNew)

    // Check for any conversations that are not claimed
    const anyAreIncoming = convos.some(convo => {
      if (Object.keys(convo).length <= 1) {
        return false
      }

      const { users = [], session } = convo
      const isYours = users.includes(id)
      const selected = current === session
      return !selected && !isYours
    })

    const anyNew = anyAreUpdated || anyAreIncoming

    if (!anyNew) {
      setBlink(false)
      return
    }

    // Start blinking and stop after 6 cycles
    setBlink(true)
    const timer = setTimeout(() => {
      setBlink(false)
    }, [ANIMATION_DURATION * 6])

    return () => {
      clearTimeout(timer)
    }
  }, [conversations, user, current])

  const classes = useStyles()

  if (!show) {
    return null
  }

  return (
    <div onClick={onClick} className={classes.root}>
      <ArrowLeft2 className={classes.icon} />

      {!hideCount && notifications.length > 0 && (
        <NewCount
          count={notifications.length}
          blink={blink}
          className={classes.count}
        />
      )}
    </div>
  )
}

export default NotificationBackButton
